import React from "react";
import ListMod from "../../../Component/Redesign/ListMod";
import {Datagrid, FunctionField, TextField} from "react-admin";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import {convertedDate} from "../../../Functions/ConvertedDate";

export const WellnessList = () => {
    const SubscriptionField = ({record}) => {
        if (!record.subscription) return 'Not Required';
        return (
            <span>{record.subscription === 1 && 'Required'}</span>
        );
    }

    const LocalsField = ({record}) => {
        if (!record.locales || !record.locales.length) {
            return '';
        }

        const lastElement = record.locales.length - 1;
        return record.locales.map((item, i) => (
            <span key={i}>{item.locale}{i === lastElement ? '' : ', '}</span>
        ))
    };

    return <div className="customTableWrap pt-32">
        <ListMod
            title={'Wellness Calls'}
            actions={false}
            sort={{field: 'show_date', order: 'DESC'}}
        >
            <Datagrid bulkActionButtons={false}>
                <FunctionField label="Show Date" source="show_date" render={(record) => {
                    return (convertedDate(record.show_date));
                }}/>
                <TextField label='Name' source="name" sortBy="name"/>
                <FunctionField label='Subscription' source="subscription" sortBy="subscription"
                               render={(record) => {
                                   return <SubscriptionField record={record}/>
                               }}/>
                <FunctionField label='Localization' source="locales" sortBy="locales" render={(record) => {
                    return <LocalsField record={record}/>
                }}/>
                <FunctionField label="" source="actions" render={(record) => {
                    return <CrudMod edit="true" del="false" id={record.id} record={record}/>;
                }}/>
            </Datagrid>
        </ListMod>
    </div>
}